module.exports = __webpack_public_path__ + "img/1.8969a7c9.svg";